export default {
    items: [
        {
            type: 'inline',
            items: [
                {
                    type: 'text-field',
                    name: 'full-name',
                    width: 0,
                    props: {
                        hidden: true,
                        formula: {
                            name: 'join',
                            arguments: {
                                targets: [
                                    'first-name',
                                    'last-name'
                                ]
                            }
                        }
                    }
                },
                {
                    type: 'text-field',
                    name: 'first-name',
                    width: 6,
                    props: {
                        label: 'First Name'
                    }
                },
                {
                    type: 'text-field',
                    name: 'last-name',
                    width: 6,
                    props: {
                        label: 'Last Name'
                    }
                }
            ]
        },
        {
            type: 'inline',
            items: [
                {
                    type: 'text-field',
                    name: 'ownership-percentage',
                    width: 3,
                    props: {
                        label: 'Ownership Percentage',
                        format: 'percent'
                    }
                }
            ]
        }
    ]
}


// WEBPACK FOOTER //
// ./src/components/deal-support/data_table_forms/owner-information.js